import React from 'react'
import ChildrenTypes from '@shapr/react-shared/types/Children'
import StorageLogic from './StorageLogic'

const AppLogic = props => {
  const { children, } = props
  return (
    <React.Fragment>
      <StorageLogic />
      {children || null}
    </React.Fragment>
  )
}

AppLogic.propTypes = {
  children: ChildrenTypes,
}

export default React.memo(AppLogic)
